/******/ (() => { // webpackBootstrap
/******/ 	"use strict";

;// ./src/styles/bundles/templates/article.css
// extracted by mini-css-extract-plugin

;// ./src/js/bundles/templates/article.js

/******/ })()
;